module.exports = __webpack_public_path__ + "static/media/3.17e2ffb4.png";